import React from 'react';
import {Head} from './react-helmet-async';

/**
 * Created to go around problem with scripts when server side rendering is broken
 * On client, use of dangerouslySetInnerHTML will NOT execute script
 */
export const IsomorphicScript = ({
  content,
  id,
}: {
  content: string;
  id: string;
}) => {
  // excluding test env -> Helmet doesnt work properly within our test with current implementation
  if (process.browser && process.env.NODE_ENV !== 'test') {
    return (
      <Head>
        <script id={id}>{content}</script>
      </Head>
    );
  }

  return (
    <script
      id={id}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    ></script>
  );
};
